import React from 'react';
import { FormattedMessage } from 'react-intl';

import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};

class SimpleSnackbar extends React.Component {
    color = (variant) => {
        switch (variant) {
            case 'success':
                return 'bg_pea';
            case 'error':
                return 'bg_lipstick';
            case 'warning':
                return 'bg_golden_yellow';
            case 'info':
                return 'bg_bluish';
            default:
                return 'bg_golden_yellow';
        }
    };

    content = (variant, text, message) => {
        const Icon = variantIcon[variant];
        const info = text !== undefined ? text : <FormattedMessage id={message} />;
        return (
            <div className="display_flex align_center">
                <Icon className="c_white margin_right_12" />
                <div className="flex_full_column text_align_left">
                    <div className="flex_full_column" dangerouslySetInnerHTML={{__html: info }} />
                </div>
            </div>
        );
    };

    render() {
        const { message, text, variant, nonavbar, noclose } = this.props;
        const _class = this.color(variant);

        return (
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                ContentProps={{
                    classes: {
                        root: 'snackbar_root bg_transparent ' + _class,
                        message: 'snackbar_message c_white barlow_regular_message text_align_center',
                        action: 'snackbar_action'
                    },
                }}
                className={nonavbar ? '' : 'bottom_resposible'}
                open={this.props.open}
                autoHideDuration={100000}
                onClose={this.props.onClose}
                message={this.content(variant, text, message)}
                action={noclose ? []: [
                    <IconButton
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={this.props.onClose}
                    >
                        <CloseIcon />
                    </IconButton>,
                ]}
            />
        );
    }
}

export default SimpleSnackbar;



// WEBPACK FOOTER //
// ./src/components/labels/Snackbar.js